import T from 'i18n-react';
import moment from 'moment';


let currentLang = '';
export const defaultLanguage = 'en';


const languages = {};

export const languageCodes = {
  'en': 'ENU',
  'da': 'DAN',
  'de': 'DEU',
  'es': 'ESP',
  'fr': 'FRA',
  'ja': 'JPN',
  'nl': 'NLD',
  'pt': 'PTB',
  'pt-BR': 'PTB',
  'sv': 'SWE',
  'zh-Hans': 'CHS',
  'fr-CA': 'FRC',
  'no': 'NOR',
  'pl': 'PLK',
  'cs': 'CSY',
};

Object.keys(languageCodes).forEach(key => {
  languages[key] = require(`../locales/${key}/strings.json`);
});

/**
 * @param {string} lang Language
 */
export const setLanguage = function(lang) {
  if (!(lang in languages)) {
    lang = defaultLanguage;
  }
  currentLang = lang;
  T.setTexts(Object.assign({}, languages[defaultLanguage].translation, languages[lang].translation));
};

export const setLocale = function(locale) {
  if (locale === 'zh-Hans') {
    locale = 'zh-CN';
  }
  moment.locale(locale);
};

export const getLanguage = () => currentLang;
